exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "h4.subhead{height:20px}.form-group{-webkit-box-flex:1;-ms-flex:1 1;flex:1 1}button.loadingBtn{cursor:progress}.error-container{margin-bottom:10px}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/scss/component/reset-password.scss
// module id = 3669
// module chunks = 3